<body>
  <app-nav-menu></app-nav-menu>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
  <app-footer id="app-footer"></app-footer>
</body>